export default {
  code: 'en', name: 'English', dir: 'ltr',
  nav: {
    dashboard: 'Dashboard', contacts: 'Contacts', companies: 'Companies', deals: 'Deals',
    tasks: 'Tasks', documents: 'Documents', procurement: 'Procurement', workflows: 'Workflows',
    intelligence: 'Intelligence', marketplace: 'Marketplace', reports: 'Reports', calendar: 'Calendar',
    customFields: 'Custom Fields', aiAssistant: 'AI Assistant', notifications: 'Notifications', settings: 'Settings',
    schedule: 'Schedule & Remind',
  },
  common: {
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', create: 'Create', update: 'Update',
    search: 'Search', filter: 'Filter', export: 'Export', import: 'Import', loading: 'Loading...',
    noData: 'No data available', confirm: 'Confirm', back: 'Back', next: 'Next', submit: 'Submit',
    yes: 'Yes', no: 'No', all: 'All', none: 'None', actions: 'Actions', status: 'Status',
    name: 'Name', email: 'Email', phone: 'Phone', date: 'Date', type: 'Type', value: 'Value',
    description: 'Description', notes: 'Notes', close: 'Close', add: 'Add', remove: 'Remove',
  },
  auth: {
    signIn: 'Sign In', signOut: 'Sign Out', signUp: 'Create Account', welcome: 'Welcome back',
    signInDesc: 'Sign in to your account to continue', createDesc: 'Get started with your free account',
    email: 'Email', password: 'Password', fullName: 'Full Name', orContinueWith: 'Or continue with',
    noAccount: "Don't have an account?", hasAccount: 'Already have an account?',
    forgotPassword: 'Forgot password?',
  },
  dashboard: {
    title: 'Dashboard', subtitle: 'Overview of your CRM performance',
    totalContacts: 'Total Contacts', companies: 'Companies', activeDeals: 'Active Deals',
    pendingTasks: 'Pending Tasks', pipelineValue: 'Pipeline Value', dealsBySector: 'Deals by Sector',
    recentActivity: 'Recent Activity',
  },
  deals: {
    title: 'Deals Pipeline', addDeal: 'Add Deal', dealTitle: 'Deal Title', dealValue: 'Value',
    stage: 'Stage', probability: 'Probability', expectedClose: 'Expected Close Date',
    sector: 'Sector', lead: 'Lead', qualified: 'Qualified', proposal: 'Proposal',
    negotiation: 'Negotiation', closedWon: 'Closed Won', closedLost: 'Closed Lost',
  },
  contacts: {
    title: 'Contacts', addContact: 'Add Contact', firstName: 'First Name', lastName: 'Last Name',
    position: 'Position', leadScore: 'Lead Score', company: 'Company', importCsv: 'Import CSV',
  },
  companies: {
    title: 'Companies', addCompany: 'Add Company', industry: 'Industry', website: 'Website',
    city: 'City', country: 'Country', size: 'Company Size', annualRevenue: 'Annual Revenue',
  },
  tasks: {
    title: 'Tasks', addTask: 'Add Task', dueDate: 'Due Date', priority: 'Priority',
    pending: 'Pending', inProgress: 'In Progress', completed: 'Completed', overdue: 'Overdue',
    low: 'Low', medium: 'Medium', high: 'High',
  },
  procurement: {
    title: 'Procurement', newProcurement: 'New Procurement', budget: 'Budget',
    infrastructure: 'Infrastructure', energy: 'Energy', telecommunication: 'Telecommunication',
    logistic: 'Logistic', transports: 'Transports', services: 'Services',
  },
  bi: {
    title: 'Business Intelligence', weightedForecast: 'Weighted Forecast', totalPipeline: 'Total Pipeline',
    winRate: 'Win Rate', crossSell: 'Cross-Sell', competitive: 'Competitive Analysis',
    businessUnits: 'Business Units', clientAcquisition: 'Client Acquisition',
    revenueForecast: 'Revenue Forecast', conversionFunnel: 'Conversion Funnel',
  },
  audit: {
    title: 'Audit Trail', subtitle: 'Compliance tracking and change history',
    action: 'Action', entity: 'Entity', user: 'User', timestamp: 'Timestamp',
    changes: 'Changes', ipAddress: 'IP Address', compliance: 'Compliance',
    exportLogs: 'Export Logs', gdprLog: 'GDPR Data Log', soxCompliance: 'SOX Compliance',
    totalLogs: 'Total Logs',
  },
  settings: {
    title: 'Settings', subtitle: 'Manage your account and preferences',
    profile: 'Profile', appearance: 'Appearance', users: 'Users', language: 'Language',
    theme: 'Theme', darkMode: 'Dark Mode', lightMode: 'Light Mode',
    selectLanguage: 'Select Language', languageDesc: 'Choose your preferred language',
  },
  marketing: {
    allProducts: 'All Products',
    hero: 'BIL Business AI',
    heroSubtitle: 'Drive measurable transformation with AI copilots that understand every deal, document and supplier in context — across your CRM, data rooms and supply chain.',
    signIn: 'Sign in',
    createAccount: 'Create a free account',
    seePricing: 'See plans & pricing',
    language: 'Language',
    nav: {
      overview: 'Overview', products: 'Products', solutions: 'Solutions',
      pricing: 'Pricing', useCases: 'Use cases', partners: 'Partners', resources: 'Resources',
      support: 'Support',
    },
    chips: {
      dataRooms: 'Data rooms', aiDealScoring: 'AI deal scoring',
      procurement: 'Procurement', compliance: 'Compliance',
    },
    cards: {
      aiDealReadiness: 'AI Deal Readiness',
      dataRooms: 'Data Rooms',
      grcAudit: 'GRC & Audit',
      workflowAI: 'Workflow AI',
      pipelineForecast: 'Pipeline Forecast',
      businessAI: 'Business AI',
      unifiedCopilot: 'UNIFIED COPILOT',
    },
    productsMenu: {
      title: 'Run every line of business with BIL.',
      blurb: 'Purpose-built apps connected by a single data fabric and Business AI copilot.',
      exploreAll: 'Explore all products',
      finance: 'Finance',
      financeDesc: 'Invoices, budgets, journals & real-time P&L.',
      procurement: 'Procurement',
      procurementDesc: 'Source-to-pay, supplier scoring & RFQs.',
      invest: 'Invest',
      investDesc: 'Marketplace to buy, sell & bid on businesses.',
      supplyChain: 'Supply Chain',
      supplyChainDesc: 'End-to-end logistics, inventory & fulfilment.',
      hr: 'Human Resources',
      hrDesc: 'Employees, leave, performance & payroll.',
      schedule: 'Schedule & Remind',
      scheduleDesc: 'Lightweight events with browser reminders — free for everyone.',
    },
    solutionsMenu: {
      title: 'Industry-ready solutions, engineered for outcomes.',
      blurb: 'Pre-configured for finance, risk, sourcing and service — deployed in weeks, not quarters.',
      exploreAll: 'Explore all solutions',
      erp: 'ERP', erpDesc: 'Unified Finance, HR & Operations on one data fabric.',
      grc: 'GRC', grcDesc: 'Governance, risk, audit & compliance command center.',
      procurement: 'Procurement', procurementDesc: 'Strategic sourcing, supplier risk & spend control.',
      cx: 'Customer Experience', cxDesc: 'CRM, service, marketing & loyalty in one copilot.',
    },
  },
};
